const initialState = {
    isLoading: false,
}

const display = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state
    }
}

export default display



// WEBPACK FOOTER //
// ./src/reducers/layout.js